/* 获取官网信息 */
export function getPageConfig (params) {
  return window.ajax({
    url: '/api/web/page/config',
    data: params
  });
}

/* 埋点统计 */
export function webStat (params) {
  return window.ajax({
    url: '/api/web/stat',
    data: params
  });
}
